<template>
  <div>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
        <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a>
      </v-col>
      <v-col md="8" sm=12 style="background-color: #FFFFFF; position: relative;" class="">
        <v-row class="signup-form overflow-hidden mx-1 mb-1" style="">
          <v-card-title class="font-weight-black">パスワード再設定</v-card-title>
          <v-card-text class="pa-5 pt-0">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <v-row>
                <v-col cols=12>
                  <ValidationProvider name="新しいパスワード" rules="required|min:8|max:16|passwordRegex" v-slot="{ errors }">
                    <v-text-field
                        label="新しいパスワード"
                        type="password"
                        v-model="request.new_password"
                        :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols=12>
                  <ValidationProvider name="新しいパスワード（再入力）" rules="required|min:8|max:16|passwordRegex" v-slot="{ errors }">
                    <v-text-field
                      label="新しいパスワード（再入力）"
                      type="password"
                      v-model="request.new_password_confirmation"
                      :error-messages="errors"
                  ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols=12 class="text-center">
                  <v-btn
                      @click="patchPasswordReset"
                      color="primary"
                      class="button-shadow ma-4"
                      width="50%"
                      type="submit"
                      :disabled="invalid"
                  >送信</v-btn>
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-card-text>
          <v-col cols=12>
            <v-row style="padding-top: 0; padding-bottom: 0;" align="center" justify="end" class="">
              <a href="/" class="btn-primary" style="font-size: 14px; text-decoration: none;">ホームに戻る</a>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "PasswordReset",
  data() {
    return {
      request: {
        new_password: '',
        m : this.$route.params.token,
      },
      new_password_confirmation: '',
      height: window.innerHeight,
    }
  },
  methods: {
    patchPasswordReset() {
      this.$store.dispatch('passwordReset/patch', this.request)
       .then(() => {
         this.$router.push({ name: 'password_reset_success' })
       })
        .catch(() => {
          //TODO: 今の実装だと共通エラーページに遷移してしまうのでここに飛んで来れない
         this.$router.push('/password_reset/failed')
      })
    }
  }
}
</script>